import request from "utils/request";

export async function unReadNotice() {
    return request.get(`/my/unReadNotice.php`,'nocache');
}

export async function noticeList(currentPage) {
    return request.get(`/my/noticeList.php?currentPage=${currentPage}`,'nocache');
}

export async function readNotice(message_id) {
    return request.get(`/my/readNotice.php?message_id=${message_id}`, 'nocache');
}

export async function noticeDetail(message_id) {
    return request.get(`/my/noticeDetail.php?message_id=${message_id}`, 'nocache');
}





